import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ScheduleIcon from "@material-ui/icons/Schedule";

import { AuthContext } from "../../context/Auth/AuthContext";
import AvisoAcesso from "../../components/AvisoAcesso";

const agoraHhmm = () =>
	new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

const formatarJanelas = janelas =>
	(janelas || []).map(j => `${j.inicio} às ${j.fim}`).join(" e ");

// Usuário logado cujo horário de acesso terminou. Quem barra é o middleware isAuth, que avalia
// Users.horariosAcesso (réplica do horário cadastrado no ERP) a cada requisição.
//
// A tela reavalia o acesso na montagem, e não só no clique: o token é preservado de propósito, e
// assim quem volta do intervalo (ou entra no segundo turno) é devolvido ao atendimento sem passar
// pelo ERP de novo. Antes o botão era um `window.location.reload()`, que recarregava nesta mesma
// URL — o boot só chama /auth/refresh_token, que não passa pelo isAuth, então nada era reavaliado
// e a tela ficava presa até o horário do dia seguinte.
const ForaHorarioAcesso = () => {
	const theme = useTheme();
	const history = useHistory();
	const { user, handleLogout, revalidarAcesso } = useContext(AuthContext);
	const [verificando, setVerificando] = useState(true);
	const [janelasHoje, setJanelasHoje] = useState([]);
	const [verificadoAs, setVerificadoAs] = useState(null);

	const verificar = async () => {
		setVerificando(true);
		const { liberado, janelasHoje: janelas } = await revalidarAcesso();
		if (liberado) {
			history.push("/tickets");
			return;
		}
		setJanelasHoje(janelas);
		setVerificadoAs(agoraHhmm());
		setVerificando(false);
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => { verificar(); }, []);

	const horarioDeHoje = formatarJanelas(janelasHoje);

	return (
		<AvisoAcesso
			icone={<ScheduleIcon />}
			corIcone={theme.palette.warning ? theme.palette.warning.main : "#f9a825"}
			titulo={`${user?.name ? `${user.name}, ` : ""}seu horário de acesso terminou`}
			mensagem="Você só pode usar o atendimento dentro do horário de acesso cadastrado para o seu
				usuário. Quando o horário voltar, acesse novamente pelo ERP."
			detalhe={
				(horarioDeHoje || verificadoAs) && (
					<>
						{horarioDeHoje && <div>Seu horário hoje: {horarioDeHoje}</div>}
						{verificadoAs && <div>Verificado às {verificadoAs} — ainda fora do horário.</div>}
					</>
				)
			}
			acoes={
				<>
					<Button
						variant="outlined"
						color="primary"
						disabled={verificando}
						startIcon={verificando ? <CircularProgress size={16} /> : null}
						onClick={verificar}
					>
						{verificando ? "Verificando..." : "Tentar novamente"}
					</Button>
					<Button variant="outlined" disabled={verificando} onClick={handleLogout}>
						Sair
					</Button>
				</>
			}
		/>
	);
};

export default ForaHorarioAcesso;
